import { render, staticRenderFns } from "./ComplaintForm.vue?vue&type=template&id=bcd86972&scoped=true"
import script from "./ComplaintForm.vue?vue&type=script&lang=js"
export * from "./ComplaintForm.vue?vue&type=script&lang=js"
import style0 from "./ComplaintForm.vue?vue&type=style&index=0&id=bcd86972&prod&lang=scss&scoped=true"
import style1 from "./ComplaintForm.vue?vue&type=style&index=1&id=bcd86972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd86972",
  null
  
)

export default component.exports